import React, { useState } from 'react';
import { Link } from 'react-scroll';

const ServiziMenu = ({
    pathname,
    location_origin,
    serviziMenuOpen,
    setServiziMenuOpen,
    togglerClose,
    setTogglerClose,
    colorMenu,
    colorMenuTOG,
    closeAll,
  }) => {
    const toggleServiziMenu = () => {
        closeAll();
        setServiziMenuOpen(!serviziMenuOpen);
    };

    const serviziMenuItems = [
        { name: "Approfondisci", href: "serviziLink", isScrollLink: true },
        { name: "Autocertificazioni", href: "autocertificazioni" },
        { name: "Documenti per la stipula", href: "documenti-stipula" },
    ];

    const renderServiziMenuItems = () => {
        const serviziPath = "servizi";
        if (!serviziMenuOpen) {
        return null;
        }
        return (
            <div className={togglerClose ? "menuDown" : "menuDownToggler"}>
            {serviziMenuItems.map((item) => (
            <li className="nav-item downMenu" key={item.name}>
                {item.isScrollLink ? (
                <Link
                    to={item.href}
                    spy={true}
                    smooth={true}
                    onClick={() => setTogglerClose(true)}
                >
                    {item.name}
                </Link>
                ) : (
                <a href={`${location_origin}${serviziPath}/${item.href}`}>{item.name}</a>
                )}
            </li>
            ))}
        </div>
        );
    };

    return (
        <li className={togglerClose ? "nav-item" : "navItemToggler"} >
        <li
            className={`nav-link ${pathname.includes('/servizi') ? 'active' : ''}`}
            onClick={toggleServiziMenu}
        >
            <a
            style={{ color: !togglerClose ? colorMenuTOG : colorMenu }}
            title='notaio treviso servizi'
            href={`${location_origin}servizi`}
            >
            Servizi
            </a>
            {serviziMenuOpen ? (
            <i
                onClick={toggleServiziMenu}
                className="fa fa-caret-up tagMenu"
                aria-hidden="true"
            />
            ) : (
            <i
                onClick={toggleServiziMenu}
                className="fa fa-caret-down tagMenu"
                aria-hidden="true"
            />
            )}
        </li>
        {renderServiziMenuItems()}
        </li>
    );
    };

export default ServiziMenu;
